import * as React from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../Navigation/Navigation';

export interface Props {
}

interface State {
}

export class NavigationSemiPro extends React.Component {
  state: State;
  props: Props;

  constructor(props: Props) {
    super(props);
  }

  render() {
    const logoStyle = {
          paddingRight: '10px',
          paddingBottom: '5px',
    };
    return (
      <Navigation>
        <Link
            className="nav-link text-black-50 "
            style={{marginLeft: '1cm', fontSize: '20px', paddingTop: '20px', fontWeight: 'normal'}}
            to="/home"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/home.png')}
                className="img-responsive"
                alt="Logo"
            />
            Accueil
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{marginLeft: '1cm', fontSize: '20px', paddingTop: '20px', fontWeight: 'normal'}}
            to="/profile"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/user.png')}
                className="img-responsive"
                alt="Logo"
            />
            Profil
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{marginLeft: '1cm', fontSize: '20px', paddingTop: '20px', fontWeight: 'normal'}}
            to="/medias"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/picture.png')}
                className="img-responsive"
                alt="Logo"
            />
            Medias
        </Link>
        <Link
            className="nav-link text-black-50 "
            style={{marginLeft: '1cm', fontSize: '20px', paddingTop: '20px', fontWeight: 'normal'}}
            to="/schedule"
        >
            <img
                style={logoStyle}
                src={require('../../../genericComponents/Images/calendar.png')}
                className="img-responsive"
                alt="Logo"
            />
            Planning
        </Link>
      </Navigation>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/genericComponents/Navigation/NavigationSemiPro/NavigationSemiPro.tsx